<template>
	<footer>
		<section
			v-if="isPeru && isCreditCard"
			class="d-flex align-center section-authorization"
			:style="`border-top: 0.1rem solid ${globalColors.primary};`"
		>
			<img :src="svg.visa" alt="">
			<p class="txt-center text-principal">Esta tienda está autorizada por Visa para realizar transacciones electrónicas.</p>
		</section>
		<section class="d-flex wrap space-between suscribe-address">
			<div class="d-flex justify-start wraper-address align-start wrap">
				<div
					class="d-flex align-start information-company"
					v-for="(store, indexStore) in storesComputed"
					:key="indexStore"
				>
					<location-svg primary class="img-location"/>
					<p>
						<span class="text-bold">{{store.name}}:</span>
						 {{store.address}}
					</p>
				</div>
				<button
					v-if="showBtn && warehouses.length > 3"
					type="button"
					class="see-more-btn"
					:style="`color: ${globalColors.primary}`"
					@click="seeMoreBtnClicked"
				>Ver más...</button>
			</div>
		</section>
		<section class="footer-info d-flex space-evenly wrap">
			<div class="flex-50 d-flex align-start wrapper-numbers">
				<div class="d-flex align-center wrapper-image">
					<HeadPhones class="head-phones"/>
				</div>
				<div>
					<div class="mb-2">
						<img 
							src="/static/img/icons/email-footer.svg" 
							alt="email"
							class="mr-1">
						<a
							class="email-store"
							:style="`color:${globalColors.titulo}`"
							:href="mailTo"
						>{{getCommerceData.email}}</a>
					</div>
					<div class="mb-2">
						<img 
							src="/static/img/icons/phone-footer.svg" 
							alt="telefono"
							class="mr-1">
						<span>{{getCommerceData.phone}}</span>
					</div>
				</div>
			</div>
			<div v-for="(content, indexContent) in contents" :key="indexContent"
				class="flex-25 mb-2 wrapper-list"
			>
				<h4
					class="title-column m0"
				>
					{{ content.name }}
				</h4>
				<ul v-for="item in content.items" :key="item.id" class="list-container mt-2">
					<li class="pointer" @click="goToHelp(content, item)">
							{{ item.name }}
					</li>
				</ul>
			</div>
		</section>
		<section class="social-media mb-2" v-if="isPeru && isCreditCard">
			<div class="social" v-for="(card, index) in cards" :key="index">
				<img 
					class="credit-card" 
					:src="card.image" 
					:alt="card.name"
					:height="card.height"
				>
			</div>
		</section>
		<div class="flex-30 txt-center wrapper-social-desktop">
			<img :src="svg.facebook" alt="facebook">
			<img :src="svg.google" alt="google">
		</div>
		<section
			class="qtc-rights d-flex align-center justify-center"
			:style="`border-top: 0.1rem solid ${globalColors.primary};`"
		>
			<a href="https://apprunn.com/" target="_blank">
				© 2019 apprunn.com. Todos los derechos reservados.
			</a>
			<div class="wrapper-social">
				<a
					v-for="(social, index) in getCommerceData.socialNetworks"
					:key="index"
					:href="social.link"
					target="_blank"
				>
					<img :src="social.logo" alt="logo de redes sociales">
				</a>
			</div>
		</section>
	</footer>
</template>
<script>
import { mapGetters } from 'vuex';
import HeadPhones from '@/components/svg-components/headPhones';
import locationSvg from '@/components/svg-components/locationSvg';

function mounted() {
	this.setContents(this.getCommerceData.helperCenter);
}

function created() {
	this.loadWarehouses();
}

function mailTo() {
	return `mailto:${this.getCommerceData.email}`;
}

function goToHelp(item, link) {
	const helpSection = item.name.split(' ').join('-');
	const newLink = link.name.split(' ').join('-');
	this.$router.push(`help/${helpSection}/seccion/${newLink}`);
}

function storesComputed() {
	const len = this.warehouses.length;
	if (len <= 3) {
		return this.warehouses;
	}
	const [store1, store2, store3] = this.warehouses;
	return this.showBtn ? [].concat(store1, store2, store3) : this.warehouses;
}

async function loadWarehouses() {
	const params = {
		flagEcommerce: 1,
	};
	try {
		const response = await this.$httpQtc.get('warehouse-public', { params });
		this.warehouses = response.data;
	} catch (error) {
		this.showGenericError();
	}
}

function seeMoreBtnClicked() {
	this.showBtn = !this.showBtn;
}

function setContents(info) {
	const sections = info.reduce((a, i) => {
		const { description, id, mainName, name, orderNumber, subTitle, urlImage } = i;
		const newItem = { description, id, mainName, name, orderNumber, subTitle, urlImage };
		const index = a.findIndex(item => item.id === i.typeHelperCenter);
		if (index > -1) {
			a[index].items.push(newItem);
		} else {
			const sectionSelected = i.section.find(s => s.id === i.typeHelperCenter);
			const section = {
				id: sectionSelected.id,
				code: sectionSelected.code,
				name: sectionSelected.name,
				items: [newItem],
			};
			a.push(section);
		}
		return a;
	}, []);
	this.contents = [...sections];
}

function data() {
	return {
		warehouses: [],
		svg: {
			callCenter: '/static/img/actionBar/headphones.svg',
			phone: '/static/img/footer/phone.svg',
			location: '/static/img/footer/location.svg',
			facebook: '/static/img/footer/facebook.svg',
			google: '/static/img/footer/google.svg',
			email: 'https://s3.amazonaws.com/apprunn-acl/COM-PRU-01/ARQ88/image/envelope.svg',
			visa: 'https://s3.amazonaws.com/apprunn-acl/COM-PRU-01/ARQ88/image/bitmap.jpg',
		},
		contents: [],
		png: {
			creditCard: '/static/img/order/visaYmasterCard.png',
		},
		cards: [
			{
				image: '/static/img/footer/visa.png',
				name: 'Visa',
				height: '30px',
			},
			{
				image: '/static/img/footer/mastercard.png',
				name: 'Mastercard',
				height: '34px',
			},
			{
				image: '/static/img/footer/american.png',
				name: 'American Express',
				height: '16px',
			},
			{
				image: '/static/img/footer/diners.png',
				name: 'Diners Club',
				height: '23px',
			},
		],
		showBtn: true,
	};
}

export default {
	name: 'Footer',
	components: {
		HeadPhones,
		locationSvg,
	},
	computed: {
		...mapGetters([
			'getCommerceData',
			'isCreditCard',
		]),
		mailTo,
		storesComputed,
	},
	data,
	created,
	methods: {
		goToHelp,
		loadWarehouses,
		seeMoreBtnClicked,
		setContents,
	},
	mounted,
};
</script>

<style lang="scss" scoped>
	footer {
		font-size: size(medium);
	}

	.suscribe-address {
		box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.08);
		padding: 2rem 15%;
	}

	.wraper-address {
		flex: 1 1 35%;

		@media (max-width: 965px) {
			align-items: flex-start;
			flex-direction: column;
		}
	}

	.footer-info {
		padding: 50px 8rem 2rem;

		@media (max-width: 965px) {
			align-items: center;
			flex-direction: column;
			padding: 2rem 0 2rem;
		}
	}
	
	.item-list {
		border-style: none;
		text-decoration: none;
		outline: none;
		color: rgb(71, 71, 71);
	}

	.list-container {
		padding: 0;
		width: 20rem;

		@media (max-width: 965px) {
			width: 100%;
		}

		li {
			list-style: none;
			line-height: 2.5rem;
		}
	}

	.social-media {
		display: flex;
		flex-wrap: wrap;
		padding: 0 8rem;

		.social {
			align-items: flex-end;
			display: flex;
			justify-content: center;

			@media screen and (max-width: 965px) {
				flex: 1 1 50%;
				margin-bottom: 2.6rem;
				text-align: center;
			}
		}

		@media screen and (max-width: 965px) {
			border-bottom: 0.1rem solid color(lineGrey);
			margin: 0 1rem;
			padding: 0;
		}
	}

	.qtc-rights {
		color: color(defaultGrey);
		font-size: size(small);
		height: 5rem;
		position: relative;

		a {
			color: color(defaultGrey);
			text-decoration: none;
		}

		@media screen and (max-width: 965px) {
			font-size: size(tiny);
		}
	}

	.contact-img {
		height: 6.1rem;
	}

	.credit-card {
		margin-right: 3rem;

		@media screen and (max-width: 965px) {
			margin-right: 0;
		}
	}

	.section-authorization {
		padding: 2rem 8rem;

		@media screen and (max-width: 965px) {
			flex-direction: column;
		}
	}
	
	.information-company {
		padding: 0 3%;
		position: relative;
		flex: 1 1 30%;
		justify-content: center;

		@media screen and (max-width: 965px) {
			flex: 1 1 auto;
			flex-direction: column;
			padding: 0 0.5rem;
			&:before {
				content: none !important;
			}
		}

		&::before {
			border: 0.05rem solid color(lineGrey);
			content: '';
			height: 4rem;
			position: absolute;
			right: 0;
		}
		&:last-child::before {
			content: none;
		}
	}

	.title-column {
		font-size: 18px;
	}

	.text-bold {
		font-family: font(avenirBold);
	}

	.img-location {
		margin-right: 1rem;
		margin-top: 1rem;
		width: 2.7rem;

		@media screen and (max-width: 965px) {
			width: 3.7rem;
		}
	}

	.wrapper-information {
		align-items: flex-start;
		display: flex;
	}

	.wrapper-image {
		border-right: 0.5px solid color(lineGrey);
		height: 8rem;
		margin-right: 1.8rem;
		padding: 1.2rem;
		width: 8rem;

		@media screen and (max-width: 965px) {
			border-right: none;
			margin: auto;
		}
	}

	.wrapper-social {
		position: absolute;
		right: 8rem;

		@media screen and (max-width: 965px) {
			display: none;
		}
		a img {
			height: 2.4rem;
			margin-left: 1rem;
			object-fit: cover;
			width: 2.4rem;
		}
	}

	.img-social {
		height: 24px;

		&:nth-child(1) {
			margin-right: 1.5rem;
		}
	}

	.wrapper-numbers {
		@media screen and (max-width: 965px) {
			align-items: center;
			border-bottom: 0.5px solid color(lineGrey);
			flex-direction: column;
			margin: 0 0 2rem 0;
			padding-bottom: 2rem;
			width: 100%;
		}
	}

	.wrapper-list {
		@media screen and (max-width: 965px) {
			text-align: center;
			width: 100%;
		}
	}

	.wrapper-social-desktop {
		display: none;
		margin: 2rem 0;

		@media screen and (max-width: 965px) {
			display: block;
		}
	}

	.email-store {
		text-decoration: none;
	}

	.text-principal {
		margin-left: 1.7rem;

		@media screen and (max-width: 965px) {
			margin-left: 0;
			width: 300px;
		}
	}

	.head-phones {
		height: 100%;
		width: 100%;
	}

	.see-more-btn {
		align-self: flex-end;
		background-color: transparent;
		border: none;
		font-family: avenir;
		padding: 1rem;

		&:hover {
			text-decoration-line: underline;
		}
	}

	.pointer {
		cursor: pointer;
	}
</style>




// WEBPACK FOOTER //
// Footer.vue?e68342d8